// extracted by mini-css-extract-plugin
export default {"icon":"OfferBox-icon_q9u4i","title":"OfferBox-title_Pn9xF"};